import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialogComponent } from '../feedback-dialog/feedback-dialog.component';

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent {
  constructor(private readonly dialog: MatDialog) {}

  get scrollBarsVisible() {
    return document.body.scrollHeight > document.body.clientHeight;
  }

  openFeedbackDialog() {
    this.dialog
      .open<FeedbackDialogComponent>(FeedbackDialogComponent, {
        autoFocus: false,
      })
      .afterClosed()
      .subscribe((data: boolean) => {
        if (data) {
        }
      });
  }
}
